module.exports = __webpack_public_path__ + "media/images/next-62074ac70bd3cfc10445d325a205a3cf.png";